import React from "react";
import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const componseResponse = (res) => {
  const data = res?.data?.data;

  return {
    providerRoom: {
      requestsFromMd: data?.provider_room.requests_from_md || 0,
    },
    mdRoom: {
      requestsReturnedByProvider:
        data?.md_room?.requests_returned_by_provider || 0,
      newPendingProcedures: {
        cosmetic: data?.md_room?.new_pending_procedures?.cosmetic || 0,
        health: data?.md_room?.new_pending_procedures?.health || 0,
      },
    },
  };
};

const responseSchema = yup.object({
  providerRoom: yup.object({
    requestsFromMd: yup.number().required(),
  }),
  mdRoom: yup.object({
    requestsReturnedByProvider: yup.number().required(),
    newPendingProcedures: yup.object({
      cosmetic: yup.number().required(),
      health: yup.number().required(),
    }),
  }),
});

export function useRoomsNotificationsQuery() {
  return useQuery({
    queryKey: [QUERY_KEYS.roomsNotifications],
    refetchOnWindowFocus: "always",
    refetchOnMount: "always",
    queryFn: async () => {
      const res = await http.get(HTTP_ENDPOINTS.getRoomsNotifications());

      return responseSchema.validateSync(componseResponse(res), {
        strict: true,
      });
    },
  });
}

export const withRoomsNotificationsQuery = (Component) => {
  return function Wrapper(props) {
    const roomsNotifications = useRoomsNotificationsQuery();
    return <Component {...props} roomsNotifications={roomsNotifications} />;
  };
};
